import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, useMediaQuery } from '@material-ui/core'
import NotificationTypeLabel from './BaseGrinNotification/NotificationTypeLabel'
import IconAndText from 'components/common/IconAndText'
import { makeStyles } from '@material-ui/styles'
import Tooltip from 'components/common/Tooltip'
import UrgentScan from 'components/common/icons/timelineV2/urgentScan'

const useStyles = makeStyles(theme => ({
  urgentScanTitle: {
    color: 'var(--urgent-scan-color)',
    fontWeight: 'bold'
  },
  reason: {
    maxWidth: ({ isSmallScreen }) => (isSmallScreen ? 100 : 185),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}))

const UrgentScanNotificationTitle = ({ reason }) => {
  const isSmallScreen = useMediaQuery('(max-width:1920px)')
  const classes = useStyles({ isSmallScreen })
  const { t } = useTranslation()

  const urgencyReasonLabel = useMemo(
    () => reason && t(`pages.patients.selectedPatient.chat.urgencyReasons.${reason}`),
    [reason, t]
  )

  return (
    <Grid container alignItems="center">
      <Grid item>
        <IconAndText
          icon={<UrgentScan color={'var(--urgent-scan-color)'} />}
          text={
            <NotificationTypeLabel className={classes.urgentScanTitle}>
              {t(`dialogs.notificationCenterDialog.notificationTypes.urgentScan`)}
            </NotificationTypeLabel>
          }
        />
      </Grid>
      {reason && (
        <>
          <Grid item style={{ margin: '0 3px' }}>
            <NotificationTypeLabel className={classes.urgentScanTitle}>•</NotificationTypeLabel>
          </Grid>
          <Grid item>
            <Tooltip
              value={t('dialogs.notificationCenterDialog.feed.notifications.urgentScan.urgencyReasonTooltip', {
                reason: urgencyReasonLabel
              })}
              placement="bottom"
            >
              <NotificationTypeLabel className={[classes.reason, classes.urgentScanTitle].join(' ')}>
                {urgencyReasonLabel}
              </NotificationTypeLabel>
            </Tooltip>
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default UrgentScanNotificationTitle
